module.exports = __webpack_public_path__ + "static/training3-888c375ac03670834c7f5ee96da3cc22.jpg";